export enum WSSMessageStatus {
    NEW = "new",
    SEEN = "seen",
}

export interface WSSMessage {
    timestamp: number;
    payload: any;
    status: WSSMessageStatus;
}

export const WSS_MESSAGE_KEY = "messagesWss";

const sortStorageList = (currentStorageList: WSSMessage[]) => {
    return currentStorageList.sort((a: any, b: any) => {
        if (a.status === WSSMessageStatus.NEW && b.status !== WSSMessageStatus.NEW) {
            return -1;
        } else if (a.status !== WSSMessageStatus.NEW && b.status === WSSMessageStatus.NEW) {
            return 1;
        } else {
            return b.timestamp - a.timestamp;
        }
    });
};

export const WSS = {
    getCurrentStorage: () => {
        const currentStorage: string = localStorage.getItem(WSS_MESSAGE_KEY) || "[]";
        const currentStorageList = JSON.parse(currentStorage);

        return currentStorageList;
    },
    pushMessage: (payload: string): number => {
        const currentStorageList = WSS.getCurrentStorage();

        if (payload) {
            const newPayloadObject: WSSMessage = {
                timestamp: Date.now(),
                payload: JSON.parse(payload),
                status: WSSMessageStatus.NEW,
            };
            if (currentStorageList.length === 0) {
                currentStorageList.push(newPayloadObject);
            } else {
                const isPresent = !!currentStorageList.filter(
                    (csl: any) => JSON.stringify(csl.payload) === payload
                ).length;

                if (!isPresent) {
                    currentStorageList.push(newPayloadObject);
                }
            }
            if (currentStorageList.length > 30) {
                currentStorageList.shift();
            }
            const reversed = currentStorageList.reverse();
            localStorage.setItem(WSS_MESSAGE_KEY, JSON.stringify(reversed));
        }
        return currentStorageList.filter((csl: WSSMessage) => csl.status === WSSMessageStatus.NEW)
            .length;
    },
    getLastMessages: (count: number) => {
        const currentStorageList = WSS.getCurrentStorage();
        sortStorageList(currentStorageList);

        return currentStorageList.slice(0, count);
    },
    clearMessages: () => {
        localStorage.setItem(WSS_MESSAGE_KEY, JSON.stringify([]));

        return [];
    },
    setAllSeen: () => {
        const currentStorageList = WSS.getCurrentStorage();

        const mapped = currentStorageList.map((csl: WSSMessage) => {
            return {
                ...csl,
                status: WSSMessageStatus.SEEN,
            };
        });

        sortStorageList(mapped);

        localStorage.setItem(WSS_MESSAGE_KEY, JSON.stringify(mapped));

        return mapped;
    },
    setSeen: (timestamp: number) => {
        const currentStorageList = WSS.getCurrentStorage();
        currentStorageList.map((csl: WSSMessage) => {
            return {
                ...csl,
                status: csl.timestamp === timestamp ? WSSMessageStatus.SEEN : csl.timestamp,
            };
        });
        sortStorageList(currentStorageList);
        localStorage.setItem(WSS_MESSAGE_KEY, JSON.stringify(currentStorageList));

        return currentStorageList;
    },
};
